import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { catchError, finalize, throwError } from 'rxjs';
import { ENDPOINTS } from '../endpoints/api-endpoints';
import { CustomToastService } from '../services/custom-toast.service';

export const interceptorService: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  const toastService: CustomToastService = inject(CustomToastService);

  const endpointsToSkipLoading: string[] = [];
  const endpointsToSkipToast: string[] = [ENDPOINTS.AUS_SERVICE.ONBOARD_SELLER,ENDPOINTS.CAMPAIGN_SERVICE.UPDATE_TRANSACTION_STATUS];

  const shouldSkipLoading = endpointsToSkipLoading.some((endpoint) => req.url.includes(endpoint));
  const shouldSkipToast = endpointsToSkipToast.some((endpoint) => req.url.includes(endpoint));

  if (!shouldSkipLoading) {
    loadingService.showOverlayLoading('Please Wait...');
  }

  return next(req).pipe(
    catchError((error) => {
      if (!shouldSkipToast) {
        toastService.error(error?.error?.error || error?.error?.message ||  'Something went wrong!');
      }
      return throwError(() => error);
    }),
    finalize(() => {
      if (!shouldSkipLoading) {
        loadingService.hideOverlayLoading();
      }
    })
  );
};
